module.exports = __webpack_public_path__ + "media/src/images/abouts/items/stores/tullys_1-87efbd3a157b3b1fda7ae6010bd021ba.jpg";